var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"display-inline"},[_vm._v("Match Transactions")]),_c('div',{staticClass:"display-inline ml-3"},[_c('ActiveApiCalls')],1),_c('p',[_vm._v("Use this tool to match bank transactions with invoices.")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('CostTransactionMatching')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }